import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AlertContext from "../../../../Context/Alert/AlertContext";
import ThemeContext from "../../../../Context/theme/ThemeContext";

const OfferUser = () => {
  const alertContext = useContext(AlertContext);
  const { showAlert } = alertContext;
  const navigate = useNavigate();
  const location = useLocation();
  const { theme } = useContext(ThemeContext);

  // Initialize OfferDetailsData with default values or values from the previous page
  const [offerDetailsData, setOfferDetailsData] = useState({
    Type: "",
    Title: "",
    Price: "",
    Delivery: "",
    Description: "",
    Buyers: [""], // Initialize with a single empty string to allow user input
    files: [],
  });

  // State to manage errors
  const [errors, setErrors] = useState({});

  // Load offer details from the previous page
  useEffect(() => {
    const { OfferDetailsData } = location.state || {};
    if (OfferDetailsData) {
      setOfferDetailsData(OfferDetailsData);
    }
  }, [location.state]);

  // Add email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim()) {
      return "Email is required";
    }
    if (!emailRegex.test(email)) {
      return "Please enter a valid email address";
    }
    return "";
  };

  // Update the handleBuyerEmailChange function
  const handleBuyerEmailChange = (index, value) => {
    const updatedBuyers = [...offerDetailsData.Buyers];
    updatedBuyers[index] = value;

    // Clear error when user starts typing
    const newErrors = { ...errors };
    delete newErrors[`email${index}`];
    setErrors(newErrors);

    setOfferDetailsData((prevDetails) => ({
      ...prevDetails,
      Buyers: updatedBuyers,
    }));
  };

  // Update the validate function
  const validate = () => {
    const newErrors = {};
    let isValid = true;
   
   // Validate each email
    offerDetailsData.Buyers.forEach((email, index) => {
      const emailError = validateEmail(email);
      if (emailError) {
        newErrors[`email${index}`] = emailError;
        isValid = false;
      }
    });

    // Check if at least one valid email exists
    if (offerDetailsData.Buyers.length === 0) {
      showAlert("At least one recipient is required", "danger");
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  // Update the addBuyer function to validate before adding
  const addBuyer = () => {
    // Check if current emails are valid before adding new one
    const currentErrors = {};
    offerDetailsData.Buyers.forEach((email, index) => {
      const emailError = validateEmail(email);
      if (emailError) {
        currentErrors[`email${index}`] = emailError;
      }
    });

    if (Object.keys(currentErrors).length > 0) {
      setErrors(currentErrors);
      showAlert(
        "Please fix existing email errors before adding more",
        "danger"
      );
      return;
    }

    setOfferDetailsData((prevDetails) => ({
      ...prevDetails,
      Buyers: [...prevDetails.Buyers, ""],
    }));
  };

  // Handle form submission
  const handleSubmit = () => {
    if (validate()) {
      navigate("/user-dashboard/offer_overview"
        , {
        state: {
          OfferDetailsData: {
            ...offerDetailsData,
            Type: offerDetailsData.Type,
          },
        },
      });
    }
  };

  return (
    <div className="flex items-center font-pop flex-col">
      <div
        className={`  rounded-2xl py-6 px-6 my-6 w-[95%] md:w-[70%] xl:w-[40%] flex flex-col gap-4    ${
          theme === "dark" ? "bg-black text-white" : "bg-white"
        }`}
      >
        <h1 className="font-semibold text-2xl">Create Offer</h1>
        <p
          className={` text-lightGrey truncate font-pop  ${
            theme === "dark" && "text-white"
          }`}
        >
          Offer Title: {offerDetailsData.Title}
        </p>
        <div className="flex flex-col gap-4">
          {offerDetailsData.Buyers.map((email, index) => (
            <div key={index} className="flex flex-col gap-1">
              <input
                type="email"
                placeholder="User Email"
                className={`w-full px-6 border-2 ${
                  errors[`email${index}`]
                    ? "border-red-500"
                    : "border-transparent"
                } font-pop text-base rounded-full ${
                  theme === "dark"
                    ? "bg-black text-white border border-white"
                    : "bg-[#E8E8E8]"
                } py-2 focus:border-primarygreen focus:outline-none`}
                value={email}
                onChange={(e) => handleBuyerEmailChange(index, e.target.value)}
              />
              {errors[`email${index}`] && (
                <p className="text-red-500 text-sm ml-4">
                  {errors[`email${index}`]}
                </p>
              )}
            </div>
          ))}
          <div
            className="flex gap-2 items-center w-full text-primarygreen cursor-pointer"
            onClick={addBuyer}
          >
            <img src="../../Assets/Prop/Add.png" alt="" className="w-6 h-6" />
            <h2>Add another recipient</h2>
          </div>

          <button
            className={`my-4 px-2 md:px-6 bg-green-500 hover:bg-transparent hover:bg-white-500 font-medium hover:text-black font-pop text-sm md:text-lg py-2 md:py-3 border border-black-500 hover:border-green-500 rounded-full text-white   ${
              theme === "dark" ? "hover:text-white" : " hover:text-black"
            }`}
            onClick={handleSubmit}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default OfferUser;
